import React, { useState } from 'react';

const ChangeBackGround = props => {
  const [backgroundIndex, setBackgroundIndex] = useState(0);
  const themeOneImages = [
    { id: 0, url: '', preViewUrl: '../img/empty.jpg', title: 'Empty' },
    { id: 1, url: '../bg/1.png', preViewUrl: '../bg/1.png', title: 'Blur Effect' },
    { id: 2, url: '../bg/2.png', preViewUrl: '../bg/2.png', title: 'Balcony View' },
    { id: 3, url: '../bg/3.png', preViewUrl: '../bg/3.png', title: 'Bright Living Room' },
    { id: 4, url: '../bg/4.png', preViewUrl: '../bg/4.png', title: 'Cozy Lounge' },
    { id: 5, url: '../bg/5.png', preViewUrl: '../bg/5.png', title: 'Modern Workspace' },
    { id: 6, url: '../bg/6.png', preViewUrl: '../bg/6.png', title: 'Conference Room' },
    { id: 7, url: '../bg/7.png', preViewUrl: '../bg/7.png', title: 'Classic Study Room' },
    { id: 8, url: '../bg/8.png', preViewUrl: '../bg/8.png', title: 'Art Wall Interior' },
    { id: 9, url: '../bg/9.png', preViewUrl: '../bg/9.png', title: 'Green Couch Room' },
    { id: 10, url: '../bg/10.png', preViewUrl: '../bg/10.png', title: 'Patio View' }
  ];


  // const themeOneImages = [
  //   {id: 0, url: '', preViewUrl: '../img/empty.jpg'},
  //   {id: 1, url: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/2.png', preViewUrl: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/2.png'}, 
  //   {id: 2, url: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/3.png', preViewUrl: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/3.png'},
  //   {id: 3, url: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/4.png', preViewUrl: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/4.png'},
  //   {id: 4, url: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/5.png', preViewUrl: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/5.png'},
  //   {id: 5, url: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/6.png', preViewUrl: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/6.png'},
  //   {id: 6, url: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/7.png', preViewUrl: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/7.png'},
  //   {id: 7, url: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/8.png', preViewUrl: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/8.png'},
  //   {id: 8, url: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/9.png', preViewUrl: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/9.png'},
  //   {id: 9, url: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/10.png', preViewUrl: 'https://vtt-ahom.s3.ap-south-1.amazonaws.com/bg_images/10.png'}
  // ];
  const handleSetBackGroundImage = (item) => {
    setBackgroundIndex(item.id)
  }
  
  return (
    <div>
      <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[999999]">
        <div className="relative w-1/2 h-[560px] rounded-3xl bg-app-yellow border border-gray-400 mb-[30px] mobile:w-full">
          <div className="pt-[15px] pb-[13px] pl-[15px] text-[15px] font-bold text-[#212025]">
            Change Background
            <span onClick={() => props.closePopup()}>
              <img
                className="cursor-pointer float-right text-center w-6 h-6 mr-5 mt-0"
                src="img/close-icon-1.png"
                alt=""
              />
            </span>
          </div>
          <div className="bg-app-purple-100 rounded-b-3xl overflow-y-auto h-[calc(100%-50.5px)] p-5 pb-[70px] relative overflow-x-hidden">
            <p className="font-medium text-sm text-app-gray-medium pt-[20px] mb-[7px] ml-[7px]">Theme 1</p>
            <div className="ml-0 flex flex-wrap gap-2">
              {themeOneImages.map((item, index) => (
                <div key={index} className="relative " >
                  <img
                    title={item?.title}
                    onClick={() => handleSetBackGroundImage(item)}
                    src={item.preViewUrl}
                    alt=""
                    style={{borderColor:  '#e8bd4f', borderWidth: '2px' , borderRadius: '20px'}}
                    className={`ml-[6px] cursor-pointer bg-app-gray-light border-4 ${backgroundIndex === item.id ? 'border-app-yellow' : 'border-app-purple-100'} rounded-[20px] w-24 h-24 hover:border-app-yellow cursor-pointer mobile:w-32`}
                  />
                  {backgroundIndex === item.id && (
                    <div className="absolute top-1 right-1 bg-app-yellow rounded-full w-5 h-5 flex items-center justify-center">
                      <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <p className="font-medium text-sm text-app-gray-medium pt-[20px] mb-[7px] ml-[7px]">Theme 2</p>
            <div className="ml-0 flex flex-wrap gap-2">
              {themeOneImages.map((item, index) => {
                if (index <= 10 && index > 5) {
                  return (
                    <div key={index} className="relative">
                      <img
                        title={item?.title}
                        onClick={() => handleSetBackGroundImage(item)}
                        src={item.preViewUrl}
                        alt=""
                        className={`ml-[6px] border-4 ${backgroundIndex === item.id ? 'border-app-yellow' : 'border-app-purple-100'} rounded-[20px] w-24 h-24 hover:border-app-yellow cursor-pointer`}
                      />
                      {backgroundIndex === item.id && (
                        <div className="absolute top-1 right-1 bg-app-yellow rounded-full w-5 h-5 flex items-center justify-center">
                          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                          </svg>
                        </div>
                      )}
                    </div>
                  );
                }
                return null;
              })}
            </div>
            <div className="text-sm font-medium text-app-blue pt-[10px] pl-[15px]"></div>

          </div>
          <div className="bg-app-purple-100 absolute bottom-0 left-0 pl-[25px] pb-[15px] pt-[17px] w-full rounded-b-[20px] text-center">
              <button
                className="text-[15px] font-bold bg-gradient-to-r from-[#363e70] to-[#ff6df8] rounded-2xl border-none text-white py-[10px] px-[15px]"
                onClick={() => {
                  props.applyBackgroundEffect(themeOneImages[backgroundIndex]?.url);
                  props.closePopup();
                }}
              >
                Apply Background Effects
              </button>
            </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeBackGround;